// NoItemsFound.jsx
import React from 'react';
import no_data from '../img/no_data.png';

const NoItemsFound = ({start_creating, visible}) => {



  return <div className="no-items" style={{display: visible}}>
    <img className="no-items-img" src={no_data} alt="no data" />
    <h2>
    Non ci sono barriere caricate.
    </h2>
    <p>
    Clicca sul pulsante sottostante per creare la prima barriera del sistema.
    </p>
    <p>
    <button onClick={start_creating}>Crea la tua prima barriera</button>
    </p>
  </div>
};

export default NoItemsFound;
